module.exports = __webpack_public_path__ + "img/haishenlizi.9f4b42a6.jpg";